<template>
	<!-- modal only used either when the session expires and user must reauth, or when the user clears all other sessions -->
	<Modal
		:id="elementId"
		:title="globalStateStore.showReLoginModal ? 'Your session expired, please log in again' : 'Logout other devices'"
		:has-form="true"
		:keyboard="false"
		:backdrop="'static'"
		:is-showing="globalStateStore.showReLoginModal"

		@submit="onFormSubmit" @clear="onFormClear" @close="onFormClear"
	>
		<LoginLayout
			:no-follow="true"
			:show-logout-sessions="elementId=='logoutSessionsModal'"
			:element-id="elementId"
			@close="onFormClear()" @submit="onFormSubmit()"/>
	</Modal>
</template>

<script lang="ts" setup>
	import AuthService from "@/services/AuthService";
	import router from "@/router";
	import { trans } from "@/helpers/i18n";
	import { defineComponent, reactive, onMounted, computed } from "vue";
	// import { getResponseError } from "@/helpers/api";
	import { useAuthStore } from "@/stores/auth";
	import { useEstateStore } from "@/stores/estate";
	import { useGlobalStateStore } from "@/stores/global";
	// import { useAlertStore } from "@/stores";
	import { usePwaStore } from "@/stores/pwa";
	import UiButton from "@/views/components/input/UiButton.vue";
	import TextInput from "@/views/components/input/TextInput.vue";
	import Modal from "@/views/components/Modal.vue";
	import { default as LoginLayout } from "@/views/pages/auth/login/LoginLayout.vue";

	import UiForm from "@/views/components/UiForm.vue";
	import { v4 as uuidv4 } from "uuid";
	import axios from "@/plugins/axios";
	import type { Estate } from "@/types/estate";
	import type { Client } from "@/types/client";

	const authService = new AuthService();
	// const alertStore = useAlertStore();
	const authStore = useAuthStore();
	const pwaStore = usePwaStore();
	const estateStore = useEstateStore();
	const globalStateStore = useGlobalStateStore();

	const form = reactive({
		email: authStore.user.email,
		password: ""
	});

	const props = defineProps<{
		elementId: string
	}>();

	onMounted(() => {
		if (!authStore.user) {
			return;
		}
		onFormClear();
	});

	async function onFormClear () {
		form.email = authStore.user.email;
		form.password = "";
		globalStateStore.showReLoginModal = false;
	}

	function validateForm () {
		return (!(form.email == "") && !(form.password == ""));
	}
	const formValidated = computed (() => {
		return validateForm();
	});

	async function onFormSubmit () {
		globalStateStore.showReLoginModal = false;
		if (formValidated.value) {
			// logic here
			onFormClear();

		}

	}

</script>
